import {VarcharDatatypeInterface} from '../postgresql/varchar-datatype.model';

export interface GuidDataFieldInterface extends VarcharDatatypeInterface {
  data?: string;
}

export class GuidDataFieldClass extends String
  implements GuidDataFieldInterface {
  data?: string;
  max_length?: number;
  not_null?: boolean;
  is_unique?: boolean;
  default_value?: string;
}
